__webpack_require__.p = "/Monsters-Rolodex/";